'use strict'

class CustomEventsBus {
  constructor () {
    this.handlers = {}

    if (window && window.addEventListener) {
      window.addEventListener('message', (event) => {
        this.handleEvent(event)
      })
    }
  }

  emitEvent (event) {
    if (!window || !window.parent || !window.parent.postMessage) {
      return
    }

    window.parent.postMessage(event, '*')
  }

  handleEvent (event) {
    if (!event.data) {
      return
    }

    if (!event.data.type) {
      return
    }

    const eventType = event.data.type
    const handlerInput = event.data

    const handlers = this.handlers[eventType] || []

    handlers.forEach((handler) => {
      handler(handlerInput)
    })
  }

  addEventListener (eventType, handler) {
    if (typeof handler !== 'function') {
      throw new Error('The provided handler is not callable')
    }

    this.handlers[eventType] = this.handlers[eventType] || []
    this.handlers[eventType].push(handler)
  }
}

const customEventsBus = new CustomEventsBus()

export { customEventsBus }



// WEBPACK FOOTER //
// ./src/helpers/CustomEventsBus.js